<script>
import { useHead } from '@unhead/vue';
// Renders a page's Facebook meta data.
export default {
  name: 'FacebookMetadata',
  render() {
    // Return null since this is only rendering meta data
    return null;
  },
  props: {
    route: {
      type: Object
    }
  },
  setup(props) {
    useHead({
      meta: [
        {
          property: 'og:title',
          content:
            props.route.fields?.facebookTitle?.value?.trim() ||
            props.route.fields?.pageTitle?.value?.trim() ||
            'Page'
        },
        {
          property: 'og:description',
          content:
            props.route.fields?.facebookDescription?.value?.trim() ||
            props.route.fields?.pageDescription?.value?.trim() ||
            ''
        },
        {
          property: 'og:image',
          content:
            props.route.fields?.facebookImage?.value?.src ||
            props.route.fields?.featuredImage?.value?.src ||
            ''
        },
        {
          property: 'og:image:width',
          content:
            props.route.fields?.facebookImage?.value?.width ||
            props.route.fields?.featuredImage?.value?.width ||
            ''
        },
        {
          property: 'og:image:height',
          content:
            props.route.fields?.facebookImage?.value?.height ||
            props.route.fields?.featuredImage?.value?.height ||
            ''
        },
        {
          property: 'og:locale',
          content: props.route.fields?.facebookLocale?.value?.trim() || 'en_US'
        },
        {
          property: 'og:site_name',
          content: props.route.fields?.facebookSiteName?.value?.trim() || 'CIS'
        },
        {
          property: 'og:type',
          content: props.route.fields?.facebookType?.value?.trim() || 'article'
        },
        {
          property: 'og:url',
          content: props.route.fields?.facebookUrl?.value?.trim() || ''
        },
        {
          property: 'article:publisher',
          content:
            props.route.fields?.articlePublisher?.value?.trim() ||
            'https://www.facebook.com/CenterforIntSec/'
        },
        {
          property: 'article:published_time',
          content: props.route.fields?.articlePublishedTime?.value?.trim() || ''
        },
        {
          property: 'article:modified_time',
          content: props.route.fields?.articleModifiedTime?.value?.trim() || ''
        }
      ].filter(
        // Remove meta items where content is not set or date is default value
        (m) => !!m.content && '0001-01-01T00:00:00Z' !== m.content
      )
    });
  }
};
</script>
